export const QUERY_PARAM = {
    size: 10,
}

export const GET_API = {
    HOST: process.env.REACT_APP_API_URL || "https://api.nhanam.updates.com.vn",
    HOME_LAYOUT: "home-layout",
}